import React, { useState, useEffect, useContext } from "react";
import { Button, Card, Skeleton } from "antd";
import HTTP from "../../services/httpService";
import { downloadCSV, formatDate, getUserRole } from "../../services/util";
import CustomHeader from "../common/Header";
import { SettingContext } from "../../routes";
import CustomTable from "../common/Table";
import { useQuery } from "react-query";

function TotalTimeDuration() {
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const { selectedDates, selectedHotels, selectedHotelType, kioskSelection } =
        useContext(SettingContext);

    const [tableData, setTableData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const hotel_ids = selectedHotels;
    const [start_date, end_date] = selectedDates;
    const [sortedInfo, updateSortedInfo] = useState({
        order: "descend",
        columnKey: "duration",
    });

    const [formData, setFormData] = useState({
        hotel_ids: hotel_ids,
        all_selected: hotel_ids.length > 0 ? false : true,
        start_date: formatDate(start_date),
        end_date: formatDate(end_date),
        page: 0,
        limit: 10,
        hotel_type: selectedHotelType,
        ...(selectedHotelType == "kiosk"
            ? { calling_hotel_type: kioskSelection }
            : {}),
        staff_id,
        sort_by: sortedInfo.columnKey,
        sorting: sortedInfo.order === "ascend" ? 2 : 1,
    });

    const columns = [
        {
            title: "Hotel",
            dataIndex: "hotel_name",
            key: "hotel_name",
            sorter: () => {},
            sortOrder:
                sortedInfo.columnKey === "hotel_name" ? sortedInfo.order : null,
        },
        {
            title: "Call Id",
            dataIndex: "call_id",
            key: "call_id",
            sortOrder:
                sortedInfo.columnKey === "call_id" ? sortedInfo.order : null,
        },
        {
            title: "Duration",
            dataIndex: "duration",
            key: "duration",
            sorter: () => {},
            sortOrder:
                sortedInfo.columnKey === "duration" ? sortedInfo.order : null,
        },
    ];

    const {
        status: totalTimeStatus,
        data: totalTimeRes,
        refetch: fetchTotalTime,
    } = useQuery(
        "totalCallTime",
        async () => {
            return await HTTP("/dashboard/getTotalCallTimeDetails", {
                ...formData,
            });
        },
        { enabled: false },
    );

    useEffect(() => {
        fetchTotalTime();
    }, []);

    useEffect(() => {
        setFormData({
            ...formData,
            calling_hotel_type: kioskSelection,
        });
    }, [kioskSelection]);

    useEffect(() => {
        const [start_date, end_date] = selectedDates;
        setFormData({
            ...formData,
            start_date: formatDate(start_date),
            end_date: formatDate(end_date),
        });
    }, [selectedDates]);

    useEffect(() => {
        const hotel_ids = selectedHotels;
        setFormData({
            ...formData,
            hotel_ids,
            page: 0,
            all_selected: hotel_ids.length === 0 ? true : false,
        });
    }, [selectedHotels]);

    useEffect(() => {
        fetchTotalTime();
    }, [formData]);

    useEffect(() => {
        if (totalTimeStatus === "success") {
            const { data, total } = totalTimeRes;
            setTableData(data);
            setTotalRecords(total);
        }
    }, [totalTimeStatus, totalTimeRes]);

    function handleTableChange(pagination, _, sorter) {
        const { current, pageSize } = pagination;
        const { order, columnKey } = sorter;
        const others = {
            page: current - 1,
            limit: pageSize,
        };
        if (order !== undefined) {
            others.sorting = order === "ascend" ? 2 : 1;
            others.sort_by = columnKey;
            updateSortedInfo({ columnKey, order });
        } else {
            delete formData.sorting;
            delete formData.sort_by;
            updateSortedInfo({});
        }

        const newFormData = {
            ...formData,
            ...others,
        };
        setFormData(newFormData);
    }

    async function downalodReport() {
        const tempFormData = { ...formData };
        delete tempFormData["page"];
        delete tempFormData["limit"];
        const res = await HTTP("/dashboard/getTotalCallTimeDetailsReport", {
            ...tempFormData,
        });
        downloadCSV(res, `time_duration_reports`);
    }

    return (
        <Card className="dashboard-container">
            <CustomHeader
                extraAfter={
                    (getUserRole() == "Super Admin" ||
                        getUserRole() == "Admin" ||
                        getUserRole() == "Management") && (
                        <Button
                            type="primary"
                            className="margin-right-5"
                            onClick={downalodReport}
                        >
                            Download
                        </Button>
                    )
                }
            />
            <Card className="box-shadow margin-10">
                {totalTimeStatus == "loading" || totalTimeStatus == "idle" ? (
                    <Skeleton
                        active
                        title={false}
                        paragraph={{ rows: 20, width: 40 }}
                    />
                ) : (
                    <CustomTable
                        columns={columns}
                        tableData={tableData}
                        noOfrecords={totalRecords}
                        handleTableChange={handleTableChange}
                        rowKey="call_id"
                        className="dashboard-table"
                    />
                )}
            </Card>
        </Card>
    );
}

export { TotalTimeDuration };
